/**
 * POS shell — the shift gate. No open shift → Open register (S41); open shift →
 * the register (S40); closing → the Z-report (S42).
 */
import { useState } from "react";
import { trpc } from "../../lib/trpc.ts";
import { RegisterPage } from "./register-page.tsx";
import { OpenRegisterPage } from "./open-register-page.tsx";
import { CloseRegisterPage } from "./close-register-page.tsx";
import { ReturnsPage } from "./returns-page.tsx";

export function PosShell() {
  const currentShift = trpc.pos.currentShift.useQuery();
  const [closingShiftId, setClosingShiftId] = useState<string | null>(null);
  const [returnsMode, setReturnsMode] = useState(false);

  if (currentShift.isLoading) {
    return <div className="grid h-screen place-items-center bg-bg text-sm text-muted">Loading register…</div>;
  }

  const shift = currentShift.data?.shift ?? null;

  if (!shift) {
    return <OpenRegisterPage onOpened={() => void currentShift.refetch()} />;
  }

  if (closingShiftId) {
    return (
      <CloseRegisterPage
        shiftId={closingShiftId}
        onClosed={() => {
          setClosingShiftId(null);
          void currentShift.refetch();
        }}
        onCancel={() => setClosingShiftId(null)}
      />
    );
  }

  if (returnsMode) {
    return <ReturnsPage onBack={() => setReturnsMode(false)} />;
  }

  return (
    <RegisterPage
      onCloseShift={() => setClosingShiftId(shift.shiftId)}
      onReturns={() => setReturnsMode(true)}
    />
  );
}
